export default __webpack_public_path__ + "static/media/Message_light.de35de60.svg";